import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "../CSS/App.css";

import { getAuth, onAuthStateChanged } from "firebase/auth";

const ContactUs = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const handleCancel = () => {
    // Navigate back to the main page
    navigate("/");
  };

  // Redirect to login if not signed in
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        navigate("/login");
      }
    });
    // Cleanup the listener when the component unmounts
    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- auth is a stable Firebase singleton, safe to omit
  }, [navigate]);

  return (
    <div
      className="container"
      style={{
        width: "80%",
        maxWidth: "400px",
        margin: "auto",
        paddingTop: "calc(20px + env(safe-area-inset-top, 0px))",
      }}
    >
      <h2>Coming Soon...</h2>
      <button
        type="button"
        onClick={handleCancel}
        style={{
          backgroundColor: "gray",
          color: "white",
          padding: "10px 15px",
          border: "none",
          cursor: "pointer",
          borderRadius: "5px",
        }}
      >
        Back
      </button>
    </div>
  );
};

export default ContactUs;
